import React from "react";
import "./Spinner.css";

class Spinner extends React.Component {

    render() {
        return(
            <div className="spinner-layer"></div>
        )
    }

}

export default Spinner;
